import { FleekError } from './FleekError';

type RecoveryCodeFailedToEncryptErrorOptions = Record<string, never>;

export class RecoveryCodeFailedToEncryptError extends FleekError<RecoveryCodeFailedToEncryptErrorOptions> {
  public name = 'RecoveryCodeFailedToEncryptError';

  toString = () => 'Failed to encrypt recovery code.';
}
